import { render, staticRenderFns } from "./JobfairDeleteProfile.vue?vue&type=template&id=6d06e350&scoped=true"
import script from "./JobfairDeleteProfile.vue?vue&type=script&lang=js"
export * from "./JobfairDeleteProfile.vue?vue&type=script&lang=js"
import style0 from "./JobfairDeleteProfile.vue?vue&type=style&index=0&id=6d06e350&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d06e350",
  null
  
)

export default component.exports